// AUTO-GENERATED SQL Builder (V40 Final) for WhatsAppTemplate
import { 
  SqlField, 
  SqlExp, 
  SqlExpChain, 
  SqlFn, 
  SqlLiteral, 
  SqlSubQuery, 
  SqlApplyColumn, 
  SqlNavHybrid, 
  createNavHybrid 
} from '../utils/sql-core';
import { SqlAst } from '../utils/sql-ast';

export class WhatsAppTemplateSql {
  private ast = new SqlAst('WhatsAppTemplate', 'whatsAppTemplate');
  public readonly main: any = {};

  public guid: SqlField;
  public code: SqlField;
  public audience: SqlField;
  public label: SqlField;
  public description: SqlField;
  public varsJson: SqlField;
  public body: SqlField;
  public enabled: SqlField;
  public id: SqlField;
  public isDeleted: SqlField;
  public createdBy: SqlField;
  public createdDate: SqlField;
  public updatedBy: SqlField;
  public updatedDate: SqlField;

  constructor() {
    this.guid = new SqlField('whatsAppTemplate', 'guid', '', 'id', 'whatsAppTemplate_guid');
    this.code = new SqlField('whatsAppTemplate', 'code', '', 'id', 'whatsAppTemplate_code');
    this.audience = new SqlField('whatsAppTemplate', 'audience', '', 'id', 'whatsAppTemplate_audience');
    this.label = new SqlField('whatsAppTemplate', 'label', '', 'id', 'whatsAppTemplate_label');
    this.description = new SqlField('whatsAppTemplate', 'description', '', 'id', 'whatsAppTemplate_description');
    this.varsJson = new SqlField('whatsAppTemplate', 'varsJson', '', 'id', 'whatsAppTemplate_varsJson');
    this.body = new SqlField('whatsAppTemplate', 'body', '', 'id', 'whatsAppTemplate_body');
    this.enabled = new SqlField('whatsAppTemplate', 'enabled', '', 'id', 'whatsAppTemplate_enabled');
    this.id = new SqlField('whatsAppTemplate', 'id', '', 'id', 'whatsAppTemplate_id');
    this.isDeleted = new SqlField('whatsAppTemplate', 'isDeleted', '', 'id', 'whatsAppTemplate_isDeleted');
    this.createdBy = new SqlField('whatsAppTemplate', 'createdBy', '', 'id', 'whatsAppTemplate_createdBy');
    this.createdDate = new SqlField('whatsAppTemplate', 'createdDate', '', 'id', 'whatsAppTemplate_createdDate');
    this.updatedBy = new SqlField('whatsAppTemplate', 'updatedBy', '', 'id', 'whatsAppTemplate_updatedBy');
    this.updatedDate = new SqlField('whatsAppTemplate', 'updatedDate', '', 'id', 'whatsAppTemplate_updatedDate');

    for (const k of Object.keys(this)) {
      const v = (this as any)[k];
      if (v instanceof SqlField) this.main[k] = v;
    }
  }

  // SELECT
  select(fn:(x:WhatsAppTemplateSql)=>any) {
    this.ast.addSelectObject(fn(this));
    return this;
  }

  // WHERE
  where(fn:(x:WhatsAppTemplateSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  and(fn:(x:WhatsAppTemplateSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  or(fn:(x:WhatsAppTemplateSql)=>SqlExp | SqlExpChain) {
    this.ast.addOr(fn(this));
    return this;
  }

  // JOIN
  join(fn:(x:WhatsAppTemplateSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f);
    return this;
  }
  leftJoin(fn:(x:WhatsAppTemplateSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'LEFT');
    return this;
  }
  rightJoin(fn:(x:WhatsAppTemplateSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'RIGHT');
    return this;
  }

  // AND JOIN
  andJoin(fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    const last = this.ast.joins[this.ast.joins.length - 1];
    if (!last) throw new Error('andJoin() before join()');

    const left = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(this.ast.alias, prop)
    });
    const right = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(last.alias, prop)
    });

    const exp = (this.ast as any).compileExp(fn(left, right));

    if (typeof last.on === 'string') {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[
          { column:last.on, operator:'', value:null, isTrusted:true, subFilters:[] },
          exp
        ]
      };
    }
    else if (last.on.logic === 'And') {
      last.on.subFilters.push(exp);
    }
    else {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[ last.on, exp ]
      };
    }

    return this;
  }

  // CTE
  with(name:string, fn:(c:any)=>any) {
    this.ast.with(name, fn);
    return this;
  }
  withRecursive(name:string, fn:(c:any)=>any) {
    this.ast.withRecursive(name, fn);
    return this;
  }

  // CTE JOIN
  joinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.joinCTE(name, alias, fn);
    return this;
  }
  fullJoinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.fullJoinCTE(name, alias, fn);
    return this;
  }

  // SUBQUERY
  subQuery(fn:(b:any)=>any) {
    return new SqlSubQuery(fn);
  }

  // APPLY
  apply(name:string, fn:(b:any)=>any) {
    this.ast.apply(name, fn);
    return this;
  }
  applyColumn(name:string, fn:(b:any)=>SqlField) {
    return this.ast.applyColumn(name, fn);
  }
  crossApply(app:any) {
    this.ast.crossApply(app);
    return this;
  }

  // GROUP BY
  groupBy(fn:(x:WhatsAppTemplateSql)=>SqlField[]) {
    this.ast.addGroup(fn(this));
    return this;
  }

  // HAVING
  having(fn:(x:WhatsAppTemplateSql)=>SqlExp | SqlExpChain) {
    this.ast.addHaving(fn(this));
    return this;
  }

  // ORDER
  orderBy(fn:(x:WhatsAppTemplateSql)=>any[]) {
    this.ast.addOrder(fn(this));
    return this;
  }

  // UNION
  union(fn:(q:any)=>any) {
    this.ast.union(fn);
    return this;
  }
  unionAll(fn:(q:any)=>any) {
    this.ast.unionAll(fn);
    return this;
  }

  limit(n:number) { this.ast.take = n; return this; }
  offset(n:number) { this.ast.skip = n; return this; }

  build() {
    return this.ast.toQueryDescriptor();
  }
}
